import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { Button, Card, CardBody, Col, FormGroup, Input, Row } from 'reactstrap'
import {
  createMessage,
  fetchConversationDetails,
  fetchMessages,
  increaseLimit,
  resetChat,
  setLoadMoreMessages,
  setTotalMessages,
} from 'store/Chats/actions'
import defaultAvatar from '../../../assets/img/brand/img_avatar.png'
import Message from './Message'
import { formatGroupMessageDate } from 'utils/helpers'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleXmark,
  faGear,
  faMinus,
  faPencil,
  faPlusCircle,
  faUsers,
  faXmark,
} from '@fortawesome/free-solid-svg-icons'
import { updateMessage } from 'store/Chats/actions'
import { setGroupMembers } from 'store/Chats/actions'
import { setAreYouSureModalData } from 'store/Recruitment/actions'
import { removeGroupMember } from 'store/Chats/actions'
import { updateGroup } from 'store/Chats/actions'

import './style.css'
import { isLoading } from 'store/EmployeeReport/actions'

export default function Chat({ setShowAddMemberModal }) {
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()
  const {
    activeConversation: conversation,
    messages: messagesRedux,
    totalMessages,
    editedMessages,
    limit,
    conversations,
    loadingMore,
    groupMembers,
    loadingMessages,
  } = useSelector((store) => store.chat)
  const { user: loggedInUser } = useSelector((store) => store.auth)

  const messageContainerRef = useRef(null)
  const [messages, setMessages] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [editInfo, setEditInfo] = useState({
    messageId: null,
    editMode: false,
  })

  const [totalMessagesState, setTotalMessagesState] = useState(null)
  const [totalEditedMessagesState, setTotalEditedMessagesState] = useState(null)

  const [editGroupMode, setEditGroupMode] = useState(false)
  const [groupPhotoPreview, setGroupPhotoPreview] = useState(null)
  const [groupName, setGroupName] = useState('')
  const [groupPhoto, setGroupPhoto] = useState(null)

  const [groupAltered, setGroupAltered] = useState(false)
  const [imageAltered, setImageAltered] = useState(false)

  useEffect(() => {
    const conversationId = location.pathname?.split('/')?.[2]

    if (!conversationId && conversations?.length > 0) {
      history.push(`/messages/${conversations[0].id}`)
    }
  }, [location.pathname, conversations, history])

  useEffect(() => {
    if (!editGroupMode) {
      setGroupAltered(false)
      setGroupName(conversation?.group_name)
      setGroupPhotoPreview(conversation?.group_image)
    }
  }, [editGroupMode, conversation?.group_image, conversation?.group_name])

  useEffect(() => {
    if (conversation?.group_name) {
      setGroupName(conversation?.group_name)
    }
    if (conversation?.group_image) {
      setGroupPhotoPreview(conversation?.group_image)
    }
  }, [conversation?.group_name, conversation?.group_image])

  const handlePhotoUpload = (e) => {
    const file = e.target.files[0]
    if (file) {
      setGroupAltered(true)
      setImageAltered(true)
      setGroupPhoto(file)
      const reader = new FileReader()
      reader.onloadend = () => {
        setGroupPhotoPreview(reader.result)
      }
      reader.readAsDataURL(file)
    }
  }

  const conversationId = location.pathname?.split('/')?.at(2)
  const firstConversation = conversations.find(
    (conversation) => conversation?.id != conversationId
  )
  const firstConvId = firstConversation ? firstConversation.id : ''

  const handleSend = () => {
    if (inputValue.trim()) {
      const newMessage = {
        message: inputValue,
        id: messages.length + 1,
        sender: 'user',
        sender_id: loggedInUser.id,
      }
      dispatch(setLoadMoreMessages(false))
      dispatch(createMessage(conversationId, inputValue))
      setMessages((prevMessages) => [...prevMessages, newMessage])
      setInputValue('')
    }
  }
  const editMessage = () => {
    if (inputValue.trim()) {
      dispatch(updateMessage(editInfo.messageId, inputValue))
      setEditInfo({ messgeId: null, editMode: false })
      setInputValue('')
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      if (!editInfo.editMode) {
        handleSend()
        e.preventDefault()
      } else {
        editMessage()
      }
    }
  }

  const user = conversation?.id ? JSON.parse(conversation?.message_user) : {}
  const lastMessage = conversations?.find(
    (element) => element?.id === conversation?.id
  )

  useEffect(() => {
    dispatch(resetChat())
    setMessages([])
    setEditGroupMode(false)
  }, [dispatch, location.pathname])

  useEffect(() => {
    if (messagesRedux?.length) {
      setMessages(messagesRedux)
    }
  }, [messagesRedux])

  useEffect(() => {
    if (!loadingMore && messageContainerRef.current) {
      messageContainerRef.current.scrollTop =
        messageContainerRef.current.scrollHeight
    }
  }, [messages, loadingMore])

  useEffect(() => {
    dispatch(fetchConversationDetails(conversationId))
  }, [dispatch, conversationId])

  useEffect(() => {
    dispatch(fetchMessages(conversationId))
  }, [conversationId, dispatch])

  useEffect(() => {
    dispatch(setTotalMessages(conversationId))

    const intervalId = setInterval(() => {
      dispatch(setTotalMessages(conversationId))
    }, 3000)

    return () => clearInterval(intervalId)
  }, [dispatch, conversationId])
  useEffect(() => {
    if (
      totalMessages &&
      !totalMessagesState &&
      editedMessages &&
      !totalEditedMessagesState
    ) {
      setTotalMessagesState(totalMessages)
      setTotalEditedMessagesState(editedMessages)
    }
  }, [
    totalMessages,
    totalMessagesState,
    editedMessages,
    totalEditedMessagesState,
  ])

  useEffect(() => {
    if (totalMessages === 0) {
      setMessages([])
    }
  }, [totalMessages])

  useEffect(() => {
    if (
      (totalMessages &&
        totalMessagesState &&
        totalMessages !== totalMessagesState) ||
      editedMessages !== totalEditedMessagesState
    ) {
      dispatch(fetchMessages(conversationId))
    }
  }, [
    conversationId,
    dispatch,
    totalMessages,
    totalMessagesState,
    editedMessages,
    totalEditedMessagesState,
  ])

  useEffect(() => {
    if (editGroupMode) {
      dispatch(setGroupMembers(conversationId))
    }
  }, [dispatch, conversationId, editGroupMode])

  const groupedMessages = Object.values(
    messages.reduce((groups, message) => {
      const date = message?.created_at?.split('T')[0]

      if (!groups[date]) {
        groups[date] = { date, messages: [] }
      }

      groups[date].messages.push(message)

      return groups
    }, {})
  )

  const userObj =
    conversation?.message_user && typeof conversation.message_user === 'string'
      ? JSON.parse(conversation.message_user)
      : null

  return (
    <Col md='7' lg='8' xl='9' style={{ paddingRight: '0' }}>
      <Card className='conversation scrollbar' style={{ overflowY: 'auto' }}>
        {(conversationId && totalMessages) ||
        (conversationId && conversation?.is_group && !loadingMessages) ? (
          <>
            <Row
              className='p-3 align-items-center'
              style={{ width: '100%', margin: '0' }}
            >
              <Col className='col-auto'>
                {!conversation?.is_group ? (
                  <img
                    alt='...'
                    className='avatar rounded-circle'
                    src={userObj?.avatar ? userObj.avatar.url : defaultAvatar}
                  />
                ) : (
                  <>
                    {conversation?.group_image ? (
                      <img
                        alt=''
                        className='avatar rounded-circle'
                        src={conversation?.group_image}
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faUsers}
                        size='lg'
                        className='mx-1'
                      />
                    )}
                  </>
                )}
              </Col>
              <div className='col d-flex flex-column ml--2'>
                <h4 className='mb-0 text-sm'>
                  {!conversation?.is_group ? (
                    <>
                      {user?.first_name} {user?.last_name}
                    </>
                  ) : (
                    conversation?.group_name
                  )}
                </h4>
                <p className='text-xs'>{user?.username}</p>
              </div>
              {conversation?.is_group && (
                <button
                  className='btn btn-danger mr-3'
                  onClick={() =>
                    dispatch(
                      setAreYouSureModalData({
                        show: true,
                        text: 'Are you sure you want to leave this chat group? You won’t receive any new messages once you leave.',
                        hideDefault: true,
                        customFn: () => {
                          history.push(`/messages/${firstConvId}`)
                          dispatch(
                            removeGroupMember(conversationId, loggedInUser.id)
                          )
                        },
                      })
                    )
                  }
                >
                  Leave Group
                </button>
              )}

              {conversation?.is_group &&
                (loggedInUser.access === 1 ||
                  loggedInUser.id === conversation?.group_creator) && (
                  <>
                    {!editGroupMode ? (
                      <button
                        onClick={() => setEditGroupMode(true)}
                        className='btn btn-info mr-3'
                      >
                        Edit Group
                        <FontAwesomeIcon
                          icon={faPencil}
                          size='lg'
                          className='ml-1'
                        />
                      </button>
                    ) : (
                      <button
                        onClick={() => setEditGroupMode(false)}
                        className='btn btn-secondary mr-3'
                      >
                        Cancel{' '}
                        <FontAwesomeIcon
                          icon={faXmark}
                          size='lg'
                          className='ml-1'
                        />
                      </button>
                    )}
                  </>
                )}
            </Row>
            {!editGroupMode ? (
              <>
                <div
                  className='chat-content scrollbar p-3'
                  ref={messageContainerRef}
                >
                  {totalMessages > limit && (
                    <div className='d-flex items-center justify-content-center'>
                      <Button
                        className='mx-auto'
                        onClick={() => {
                          if (messageContainerRef.current) {
                            const prevScrollTop =
                              messageContainerRef.current.scrollTop
                            const prevScrollHeight =
                              messageContainerRef.current.scrollHeight

                            dispatch(setLoadMoreMessages(true))
                            dispatch(increaseLimit())
                            dispatch(fetchMessages(conversationId))

                            setTimeout(() => {
                              if (messageContainerRef.current) {
                                const newScrollHeight =
                                  messageContainerRef.current.scrollHeight
                                const scrollDiff =
                                  newScrollHeight - prevScrollHeight

                                messageContainerRef.current.scrollTop =
                                  prevScrollTop + scrollDiff
                              }
                            }, 100)
                          }
                        }}
                      >
                        Load more messages
                      </Button>
                    </div>
                  )}
                  {groupedMessages.map((group) => (
                    <div key={group.date}>
                      {group.date && (
                        <h3 className='text-center my-3'>
                          {formatGroupMessageDate(group.date)}
                        </h3>
                      )}

                      {group.messages.map((message, index) => {
                        const previousMessage =
                          index > 0 ? group.messages[index - 1] : null
                        const nextMessage =
                          index < group.messages.length - 1
                            ? group.messages[index + 1]
                            : null

                        const isFirstInBlock =
                          conversation?.is_group &&
                          (!previousMessage ||
                            previousMessage.sender_id !== message.sender_id)

                        const isLastInBlock =
                          conversation?.is_group &&
                          (!nextMessage ||
                            nextMessage.sender_id !== message.sender_id)

                        return (
                          <Message
                            key={message.id}
                            message={{ ...message, index }}
                            loggedInUser={loggedInUser}
                            lastMessage={lastMessage}
                            setInputValue={setInputValue}
                            editInfo={editInfo}
                            setEditInfo={setEditInfo}
                            isGroup={conversation?.is_group}
                            isFirstInBlock={isFirstInBlock}
                            isLastInBlock={isLastInBlock}
                          />
                        )
                      })}
                    </div>
                  ))}
                </div>
                <div className='bottomContainer'>
                  {editInfo.editMode && (
                    <FontAwesomeIcon
                      title='Exit edit mode'
                      icon={faCircleXmark}
                      size='2x'
                      role='button'
                      onClick={() => {
                        setEditInfo({ messgeId: null, editMode: false })
                        setInputValue('')
                      }}
                    />
                  )}
                  <Input
                    className='messageInput'
                    placeholder='Type a message...'
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />

                  {!editInfo.editMode ? (
                    <Button
                      className='messageButton'
                      color='info'
                      type='button'
                      onClick={handleSend}
                    >
                      Send
                    </Button>
                  ) : (
                    <Button
                      className='messageButton'
                      color='info'
                      type='button'
                      onClick={() => {
                        dispatch(updateMessage(editInfo.messageId, inputValue))
                        setEditInfo({ messgeId: null, editMode: false })
                        setInputValue('')
                      }}
                    >
                      Edit
                    </Button>
                  )}
                </div>
              </>
            ) : (
              <div className='w-75 mx-auto'>
                {/* Group Photo Upload */}
                <div
                  className='mx-auto mb-4'
                  style={{
                    width: 150,
                    height: 150,
                    border: '2px dashed #ccc',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    cursor: 'pointer',
                  }}
                  onClick={() =>
                    document.getElementById('group-photo-input').click()
                  }
                >
                  {groupPhotoPreview ? (
                    <img
                      src={groupPhotoPreview}
                      alt='Group'
                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        objectFit: 'cover',
                      }}
                    />
                  ) : (
                    <i
                      className='fa fa-camera'
                      style={{ fontSize: 32, color: '#888' }}
                    />
                  )}
                  <input
                    id='group-photo-input'
                    type='file'
                    accept='image/*'
                    style={{ display: 'none' }}
                    onChange={handlePhotoUpload}
                  />
                </div>
                <FormGroup className='ml-0'>
                  <Input
                    id='exampleFormControlInput1'
                    name='last_name'
                    placeholder='Group name'
                    type='text'
                    style={{ height: '37px' }}
                    value={groupName}
                    onChange={(e) => {
                      setGroupName(e.target.value)
                      setGroupAltered(true)
                    }}
                  />
                </FormGroup>
                <div className='my-3'>
                  <button
                    disabled={!groupAltered}
                    onClick={() => {
                      dispatch(
                        updateGroup(
                          conversationId,
                          groupName,
                          imageAltered ? groupPhoto : null
                        )
                      )
                      setGroupAltered(false)
                      setImageAltered(false)
                    }}
                    className='btn btn-info'
                  >
                    Save Changes
                  </button>
                </div>
                <Card className='my-3'>
                  <CardBody
                    className='group-member-card d-flex align-items-center'
                    onClick={() => setShowAddMemberModal(true)}
                  >
                    <FontAwesomeIcon
                      icon={faPlusCircle}
                      className='mr-2'
                      style={{
                        width: '35px',
                        height: '35px',
                        borderRadius: '50%',
                      }}
                    />
                    Add members
                  </CardBody>
                  {groupMembers && groupMembers.length
                    ? groupMembers.map((member) => {
                        const avatarObj =
                          member.avatar && typeof member.avatar === 'string'
                            ? JSON.parse(member.avatar || '{}')
                            : {}

                        const avatarUrl = avatarObj?.url || defaultAvatar

                        return (
                          <CardBody
                            key={member.user_id}
                            className='d-flex align-items-center group-member-card justify-content-between'
                          >
                            <div className='d-flex align-items-center'>
                              <img
                                src={avatarUrl}
                                alt='User Avatar'
                                style={{
                                  width: '35px',
                                  height: '35px',
                                  borderRadius: '50%',
                                  objectFit: 'cover',
                                  marginRight: '10px',
                                }}
                              />
                              <span className='font-weight-bolder'>
                                {member.first_name} {member.last_name}
                              </span>
                            </div>
                            {member.user_id !== loggedInUser.id && (
                              <button
                                onClick={() =>
                                  dispatch(
                                    setAreYouSureModalData({
                                      show: true,
                                      customFn: () =>
                                        dispatch(
                                          removeGroupMember(
                                            conversationId,
                                            member.user_id
                                          )
                                        ),
                                    })
                                  )
                                }
                                className='btn btn-danger'
                              >
                                Remove from group{' '}
                                <FontAwesomeIcon icon={faMinus} />
                              </button>
                            )}
                          </CardBody>
                        )
                      })
                    : null}
                </Card>
              </div>
            )}
          </>
        ) : (
          <div
            className='text-center d-flex align-items-center justify-content-center'
            style={{ height: '100%' }}
          >
            {loadingMessages && (
              <div
                className='d-flex flex-column justify-content-center align-items-center'
                style={{ gap: '20px' }}
              >
                <div className='spinner-border text-primary' role='status'>
                  <span className='sr-only'>Loading...</span>
                </div>
              </div>
            )}

            {!loadingMessages && !conversationId && (
              <p>No conversation selected.</p>
            )}
          </div>
        )}
      </Card>
    </Col>
  )
}
